// Возвращает True — если скролл вверх, возвращает False — если скролл вниз
function detectScrollDirection(event) {
	var delta = parseInt(event.originalEvent.wheelDelta || -event.originalEvent.detail);
		
	if (delta >= 0) return true;
	else false;
}